import React from 'react';
import _ from 'lodash';
import { Modal, Card, CardContent, CardHeader, IconButton, Stack, Alert, Button, Portal, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

export default function SectionForm({ open, handleClose, parentSectionId, addNewSectionCallback, choices, officeView = false }) {
  const [category, setCategory] = React.useState('');
  console.log(choices);

  const handleSubmit = () => {
    const formData = { parentSectionId, otherCategory: category };
    const success = addNewSectionCallback(formData);
    if (success) {
      handleClose();
    }
  };

  React.useEffect(() => {
    if (open === false) {
      setCategory('');
    }
  }, [open]);

  return (
    <Portal>
      <Modal open={open} onClose={handleClose}>
        <Card sx={{ ...style, width: '500px' }}>
          <CardHeader
            title="Wczytaj plik"
            action={
              <IconButton color="primary" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            }
          />
          <CardContent>
            <Stack spacing={3} justifyContent="flex-start" alignItems="flex-start">
              <Stack direction="column" spacing={2} alignItems="center">
                <FormControl sx={{ minWidth: ' 160px' }}>
                  <InputLabel variant="standard" htmlFor="uncontrolled-native">
                  Wybierz kategorię
                  </InputLabel>
                  <Select
                    placeholder="Wybierz kategorię"
                    variant="standard"
                    labelId="category"
                    value={category}
                    defaultValue={null}
                    label="Kategoria"
                    onChange={e => setCategory(e.target.value)}
                  >
                    {choices &&
                    choices.other_categories.map(obj => (
                      <MenuItem key={obj.value} value={obj.value}>
                        {obj.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Stack>
              <Button variant="contained" fullWidth onClick={handleSubmit} disabled={!category}>zapisz</Button>
            </Stack>
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
};
